var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{opened: _vm.isopened},attrs:{"id":_vm.id}},[(_vm.openedCollid)?_c('FlagCollection',{attrs:{"collection":_vm.flagcolls[_vm.openedCollid]}}):_vm._e()],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }